<script setup lang="ts">
import { createNewGeschaeft } from '@/models/Planungsgeschaeft';
import { useAuthUser } from '@/helpers/globals';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

const user = useAuthUser();
const router = useRouter();

onMounted(async () => {
    if (user) {
        try {
            const newGeschaeft = await createNewGeschaeft();
            if (newGeschaeft?.id) {
                // gemäss Ticket #28737 direkt in zu Ihre Angaben (ehemals Editor)
                router.push({ name: 'planungsgeschaeft-edit-editor', params: { id: newGeschaeft.id } });
            }
        } catch (e) {
            router.push({ name: 'planungsgeschaefte-overview' });
        }
    } else {
        router.push({ name: 'planungsgeschaefte-overview' });
    }
});
</script>
<template>
    <div class="flex new">
        <ktg-loader color="black" alt="Loading"></ktg-loader>
    </div>
</template>
<style lang="css" scoped>
.new {
    justify-content: space-around;
    align-items: flex-start;
    height: 20rem;
}
</style>
